import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";

import useCookies from "../../../hooks/useCookies";
import { revertToOriginalSession } from "../../../store/actions/sessionActions";
import { ITile } from "../../../store/slices/environmentSlice";
import { showModal } from "../../../store/slices/modalSlice";
import { useTypedDispatch, useTypedSelector } from "../../../store/store";
import AGENT_HOME from "../../../utils/constants/agentHome";
import MODAL from "../../../utils/constants/modal";
import Button from "../../shared/Button";
import CustomTiles from "../../shared/CustomTiles";

import styles from "./index.module.scss";

function AgentHome() {
  const { t } = useTranslation();
  const dispatch = useTypedDispatch();
  const { getCookie } = useCookies();

  const { name, agentDetails } = useTypedSelector((state) => state.session);

  const { agent_home_tiles, brand } = useTypedSelector(
    (state) => state.environment,
  );

  const isActingOnBehalf = !!getCookie("active_sessionKey");

  const parsedTiles: ITile[] = useMemo(() => {
    const parsed = JSON.parse(agent_home_tiles);

    if (Array.isArray(parsed)) {
      return parsed.map((tile: any) => ({
        ...tile,
        target: "_blank" as const,
      }));
    }

    return [];
  }, [agent_home_tiles]);

  const allTiles: ITile[] = useMemo(() => {
    return [...AGENT_HOME.TILES, ...parsedTiles];
  }, [parsedTiles]);

  const handleSwitchAgentClick = () => {
    dispatch(
      showModal({
        type: MODAL.MODAL_TYPES.SWITCH_AGENT,
        size: MODAL.MODAL_SIZES.SM,
      }),
    );
  };

  const handleRevertClick = () => {
    dispatch(revertToOriginalSession());
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.greetingContainer}>
          <div className={styles.greetingHeader}>
            <div>
              <h1 className={styles.title}>{`${t("hello")} ${name}`}</h1>
              <div className={styles.subTitle}>
                <Trans
                  ns="agentHome"
                  i18nKey={`${brand ?? "default"}.title`}
                  components={{
                    brochureLink: (
                      <a
                        href="https://nicko-cruises.blaetterkatalog.de/?catalog=RiverCruisesFor2026"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="nicko cruises brochure"
                      />
                    ),
                    emailLink: (
                      <a
                        href="mailto:nickocruises.ca@discovertheworld.com"
                        aria-label="nickocruises.ca@discovertheworld.com"
                      />
                    ),
                  }}
                />
              </div>
            </div>

            <div className={styles.behalfActionsContainer}>
              {(agentDetails?.switch_agent || isActingOnBehalf) && (
                <Button
                  className={styles.switchAgentButton}
                  size="md"
                  label={t("switch agent")}
                  onClick={handleSwitchAgentClick}
                />
              )}

              {agentDetails && isActingOnBehalf && (
                <Button
                  className={styles.switchAgentButton}
                  size="md"
                  label={t("Return to Original")}
                  onClick={handleRevertClick}
                  variant="secondary"
                />
              )}
            </div>
          </div>
        </div>

        <CustomTiles tiles={allTiles} />
      </div>
    </div>
  );
}

export default AgentHome;
